import DashboardPageLayout from "../../components/layout/DashboardPageLayout";
import FeriadosPage from "../../pages/Feriado/FeriadosPage";
import NovoFeriadoPage from "../../pages/Feriado/NovoFeriadoPage";

import HomePage from "../../pages/home/HomePage";
import PerfisPage from "../../pages/Perfis/PerfisPage";
import PostosCombustivelPage from "../../pages/PostosCombustivel/PostosCombustivelPage";
import UsuariosPage from "../../pages/Usuarios/UsuariosPage";
import { RouteType } from "../config";
import SettingsIcon from "@mui/icons-material/Settings";

const grupoConfiguracao: RouteType = {
  path: "/configuracoes",
  element: <DashboardPageLayout />,
  state: "configuracoes",
  show: true,
  verificarPermissao: (usuario) => {
    if (
      !usuario?.perfil.podeCadastrarUsuario &&
      !usuario?.perfil.podeCadastrarPerfil
    ) {
      return false;
    } else {
      return true;
    }
  },
  sidebarProps: {
    displayText: "Configurações",
    icon: <SettingsIcon />,
  },

  child: [
    {
      index: true,
      element: <HomePage />,
      state: "configuracao.index",
      show: true,
    },
    {
      path: "/configuracoes/feriados",
      element: <FeriadosPage />,
      state: "configuracao.feriados",
      show: true,
      verificarPermissao: (usuario) => {
        return usuario?.perfil.podeCadastrarFeriado ?? false;
      },
      sidebarProps: {
        displayText: "Feriados",
      },
    },

    {
      path: "/configuracoes/postos",
      element: <PostosCombustivelPage />,
      state: "configuracao.postos",
      show: true,
      verificarPermissao: (usuario) => {
        return usuario?.perfil.podeCadastrarPerfil ?? false;
      },
      sidebarProps: {
        displayText: "Postos de combustível",
      },
    },
    {
      path: "/configuracoes/usuarios",
      element: <UsuariosPage />,
      state: "configuracao.usuario",
      show: true,
      verificarPermissao: (usuario) => {
        return usuario?.perfil.podeCadastrarUsuario ?? false;
      },
      sidebarProps: {
        displayText: "Usuários",
      },
    },
    {
      path: "/configuracoes/perfis",
      element: <PerfisPage />,
      state: "configuracao.perfil",
      show: true,
      verificarPermissao: (usuario) => {
        return usuario?.perfil.podeCadastrarPerfil ?? false;
      },
      sidebarProps: {
        displayText: "Perfis",
      },
    },

    {
      path: "/configuracoes/feriado/cadastro",
      element: <NovoFeriadoPage />,
      state: "feriado.cadastro",
      show: false,
      sidebarProps: {
        displayText: "Cadastrar Feriado",
      },
    },
  ],
};

export default grupoConfiguracao;
